/**
 * Centralized date formatters for the PROcess UI.
 *
 * The product convention is DD/MM/YYYY (Malaysian / European format) for
 * every user-facing date. Filenames intentionally stay on ISO YYYY-MM-DD
 * so that sorted directory listings still make sense.
 *
 * All helpers tolerate null/undefined/invalid input and return "—" so the
 * UI never shows the literal "Invalid Date" string.
 */
const PLACEHOLDER = "—";

function _toDate(v) {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

function _pad(n) {
  return String(n).padStart(2, "0");
}

/** DD/MM/YYYY — eg "16/06/2026" */
export function formatDate(value) {
  const d = _toDate(value);
  if (!d) return PLACEHOLDER;
  return `${_pad(d.getDate())}/${_pad(d.getMonth() + 1)}/${d.getFullYear()}`;
}

/** DD/MM/YYYY HH:mm — eg "16/06/2026 14:32" (24h clock) */
export function formatDateTime(value) {
  const d = _toDate(value);
  if (!d) return PLACEHOLDER;
  return `${formatDate(d)} ${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}

/** HH:mm — eg "14:32" (24h clock) */
export function formatTime(value) {
  const d = _toDate(value);
  if (!d) return PLACEHOLDER;
  return `${_pad(d.getHours())}:${_pad(d.getMinutes())}`;
}
